<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Actividad
            <router-link :to="{ name: 'Actividades' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.nombre.$model"
                  :isValid="checkIfValid('nombre')"
                  label="Nombre de la actividad:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 50 caracteres"
                />
              </CCol>
            </CRow>
            
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Pertenece a:</label>
                <v-select
                  v-model="pertenece_id"
                  class="margin-multi"
                  :options="actividades"
                  placeholder="Selecciona una actividad"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
                <!-- <CSelect
                  :value.sync="actividad"
                  horizontal
                  :options="actividades"
                  placeholder="Selecciona una actividad"
                />-->
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Tipo:</label>
                <v-select
                  v-model="tipo_act"
                  class="margin-multi"
                  :options="tipo_actividad"
                  placeholder="Selecciona un tipo"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Tipo de pago:</label>
                <v-select
                  v-model="tipo_pago"
                  class="margin-multi"
                  @input="tipoPago()"
                  :options="tipo"
                  placeholder="Selecciona un tipo de pago"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Multiplicador de pago:</label>
                <v-select
                  v-model="multiplicador_pago"
                  class="margin-multi"
                  :disabled="isDiabled"
                  :options="multi"
                  placeholder="Selecciona un multiplicador de pago"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
                <!-- <CSelect
                  :value.sync="multiplicador_pago"
                  horizontal
                  :disabled="isDiabled"
                  :options="multi"
                  placeholder="Selecciona un multiplicador de pago"
                />-->
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.unidad.$model"
                  :isValid="checkIfValid('unidad')"
                  label="Unidad:"
                  placeholder="Unidad..."
                  invalidFeedback=" El campo debe tener como maximo 5 caracteres"
                />
              </CCol>
            </CRow>

            <CRow v-if="checkSerie()">
              <CCol>
                <label>Habilitar numero de serie:</label>
                <br />
                <CSwitch
                  @update:checked="numSerie()"
                  :checked="numero_serie"
                  class="mx-1 ml-3"
                  color="primary"
                  variant="3d"
                />
              </CCol>
            </CRow>
            <CRow v-if="checkBascula()">
              <CCol>
                <label>Habilitar bascula:</label>
                <br />
                <CSwitch
                  :checked="bascula"
                  @update:checked="mBascula()"
                  class="mx-1 ml-3"
                  color="primary"
                  variant="3d"
                />
              </CCol>
            </CRow>

            <CRow v-if="pertenece_id_value">
              <CCol sm="9">
                <label>Tipo de costo:</label>
                <v-select
                  :options="tiposCosto"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona un tipo de costo"
                  v-model="tipo_costo"
                  :class="checkIfValid('tipo_costo')===false?'is-invalid':''"
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 50 caracteres"
                >
                  <template #footer v-if="checkIfValid('tipo_costo')===false">
                    <div class="invalid-feedback">Campo requerido</div>
                  </template>
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>
            
            <ExtraConfigInput
              title=""
              parametro="actividades_atributos_extras"
              v-model="fieldsExtra"
              @config="config => fieldsExtraConfig = config"
              @onValid="v=>valid=v"
            />
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Actividades' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton
              @click="addActividad()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Actividad"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import ExtraConfigInput from './../../customComponents/ExtraConfigInput.vue'

export default {
  name: "NuevoActividad",

  components: {
    vSelect,
    ExtraConfigInput,
  },

  data() {
    return {
      id: this.$route.params.id,
      item: {},
      actividades: [],
      pertenece_id: null,
      tipo_act: "",
      tipo_actividad: [
        { value: 1, label: "cultural" },
        { value: 2, label: "cosecha" }
      ],
      tipo: [
        { value: 1, label: "fijo" },
        { value: 2, label: "variable" }
      ],
      multi: [
        { value: 1, label: "evento" },
        { value: 2, label: "cantidad" }
      ],
      tipo_costo: null,
      tiposCosto:[{ value: 'cosecha', label: 'Cosecha' },{ value: 'no_cosecha', label: 'No cosecha' }],
      nombre: "",
      tipo_pago: "",
      multiplicador_pago: "",
      unidad: "",
      isDiabled: false,
      warningModal: false,
      error: "",
      fieldsExtraConfig: [],
      fieldsExtra: {},
      numero_serie: false,
      bascula: false,
      isSerie: false,
      isLoading: false,
      isLoadingPage: false,
      valid: {flag: true}
    };
  },

  mixins: [validationMixin],
  validations: {
    nombre: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)
    },
    unidad: {
      
    },
    tipo_costo: {
      required: (v,data)=>{
        return data.pertenece_id?.value?(v?.value||false):true
      },
    }
  },

  created() {
    this.isLoadingPage = true;
    const act = [
      this.$store.dispatch("customHTTP", {
        schema: "actividades",
        filter: {
          where: [
            {
              field: "payload->tipo_pago",
              value: "",
              operator: "="
            },
            {
              field: "payload->multiplicador_pago",
              value: "",
              operator: "="
            },
            {
              field: "payload->unidad",
              value: "",
              operator: "="
            }
          ]
        }
      }),
      this.$store.dispatch("customHTTP", {
        schema: "actividades",
        filter: {
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            }
          ]
        }
      })
    ];

    Promise.all(act)
      .then(([actividades, item]) => {
        this.actividades = actividades.data.map(actividad => {
          return { value: actividad.id, label: actividad.payload.nombre };
        }).sort((a,b)=>a.label.toUpperCase().localeCompare(b.label.toUpperCase()));
        this.item = item.data[0];
        this.nombre = this.item.payload.nombre;
        this.tipo_costo = this.tiposCosto.find(f=>f.value == this.item.payload.tipo_costo);
        // eslint-disable-next-line no-prototype-builtins
        if (this.item.payload.hasOwnProperty("serie")) {
          this.item.payload.serie
            ? (this.numero_serie = true)
            : (this.numero_serie = false);
        }
        // eslint-disable-next-line no-prototype-builtins
        if (this.item.payload.hasOwnProperty("bascula")) {
          this.item.payload.bascula
            ? (this.bascula = true)
            : (this.bascula = false);
        }

        this.numero_serie = this.item.payload.serie;
        this.pertenece_id = this.actividades.find(
          act => act.value == this.item.payload.pertenece_id
        );
        // this.tipo_pago = this.item.payload.tipo_pago;
        this.tipo_pago = this.tipo.find(
          tipo => tipo.label == this.item.payload.tipo_pago
        );
        this.tipo_act = this.tipo_actividad.find(
          tipo => tipo.label == this.item.payload.tipo
        );

        // this.multiplicador_pago = this.item.payload.multiplicador_pago;
        this.multiplicador_pago = this.multi.find(
          mul => mul.label == this.item.payload.multiplicador_pago
        );
        console.log(this.multiplicador_pago);

        this.unidad = this.item.payload.unidad;

        if (this.tipo_pago) {
          if (this.tipo_pago.label == "fijo") {
            this.multiplicador_pago = { value: 2, label: "cantidad" };
            this.isDiabled = true;
          } else {
            this.isDiabled = false;
          }
        } else {
          this.multiplicador_pago = null;
          this.isDiabled = false;
        }

        if(this.item.payload.extras !== undefined){
          let fieldsExtraPayload = Object.entries(this.item.payload.extras);
          for (let index = 0; index < fieldsExtraPayload.length; index++) {
            const fieldExtra = fieldsExtraPayload[index];
            this.fieldsExtra[fieldExtra[0]] = fieldExtra[1]
          }
        }
      })
      .finally(() => (this.isLoadingPage = false));
  },

  computed: {
    pertenece_id_value(){
      return this.pertenece_id?.value?true:false
    },
    isValidActividad() {
      return !this.$v.nombre.$invalid;
    },
    isValidUnidad() {
      return !this.$v.unidad.$invalid;
    },
    isValidTipoCosto() {
      return !this.$v?.tipo_costo.$invalid;
    }
  },

  methods: {
    numSerie() {
      this.numero_serie = !this.numero_serie;
    },
    mBascula() {
      this.bascula = !this.bascula;
    },
    checkSerie() {
      if (this.tipo_pago && this.multiplicador_pago) {
        if (
          this.tipo_pago.label == "variable" &&
          this.multiplicador_pago.label == "evento"
        ) {
          return true;
        }
      }
      return false;
    },
    checkBascula() {
      if (this.tipo_pago && this.multiplicador_pago) {
        if (
          this.tipo_pago.label == "variable" &&
          this.multiplicador_pago.label == "evento"
        ) {
          return true;
        }
      }
      this.bascula = false
      return false;
    },
    tipoPago() {
      if (this.tipo_pago) {
        if (this.tipo_pago.label == "fijo") {
          this.multiplicador_pago = { value: 2, label: "cantidad" };
          this.isDiabled = true;
        } else {
          this.isDiabled = false;
        }
      } else {
        this.multiplicador_pago = null;
        this.isDiabled = false;
      }
    },
    addActividad() {
      this.validateActividad();
      
      if(!this.valid.flag){
        const valores = this.valid.valores
        this.error = `Son requeridos los campos: ${valores.join(', ')}`;
        this.warningModal=true
        return
      }
      if (this.isValidActividad && this.isValidUnidad && this.isValidTipoCosto) {
        this.isLoading = true;

        // clean numbers extra fileds

        this.fieldsExtraConfig.forEach(indexField => {
          if (indexField.tipo === "number") {
            this.fieldsExtra[indexField.nombre] =
              Number(this.fieldsExtra[indexField.nombre]) || 0;
          }
          if (indexField.tipo === "text") {
            this.fieldsExtra[indexField.nombre] =
              this.fieldsExtra[indexField.nombre] || "";
          }
        });

        const newAct = this.$store.dispatch("customActualizarHTTP", {
              schema: "actividades",
              id: this.id,
              payload: {
                nombre: this.nombre,
                pertenece_id: this.pertenece_id ? this.pertenece_id.value : 0,
                tipo_costo: this.tipo_costo ? this.tipo_costo.value : '',
                tipo: this.tipo_act ? this.tipo_act.label : "",
                tipo_pago: this.tipo_pago ? this.tipo_pago.label : "",
                multiplicador_pago: this.multiplicador_pago
                  ? this.multiplicador_pago.label
                  : "",
                unidad: this.unidad,
                ...(this.fieldsExtraConfig.length > 0)?{extras: this.fieldsExtra}:{},
                ... this.checkSerie()
                  ? {
                    serie: this.numero_serie,
                    bascula: this.bascula,
                  }:{}
              }
            })
          

  
        newAct
          .then(() => {
            this.$router.push({ name: "Actividades" });
          })
          .catch(rej => {
            this.error = rej.message;
            this.warningModal = true;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field?.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateActividad() {
      this.$v.$touch();
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
